import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { useContext } from "react"

interface StreamNameProps {
  unitId?: string
}
export function StreamName(props: StreamNameProps) {
  const {unitId} = props;
  const {getCellById} = useContext(FlowsheetContext)
  if (!unitId) {
    return '-'
  }

  return getCellById(unitId)?.tag ?? '-'
}